// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".events-wrapper{padding:0 16px}@media (min-width:768px){.events-wrapper{padding:0 26px}}", ""]);
// Exports
module.exports = exports;
